// src/hooks/useTopTags.js
import { useEffect, useState } from "react";
// --- update this import to match your firebase init file
// Common patterns:
// import { getFirestore } from "../firebase";           // if you export getFirestore()
// import { db } from "../firebase";                    // if you export a db instance
import { getFirestore, collection, query, orderBy, limit, onSnapshot } from "firebase/firestore";

export default function useTopTags(limitNum = 12) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    // If you already export 'db' from your firebase init, replace the next line with:
    // const db = require("../firebase").db;
    const db = getFirestore();

    const q = query(collection(db, "tags"), orderBy("count", "desc"), limit(limitNum));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const arr = [];
        snap.forEach((doc) => {
          arr.push({ id: doc.id, ...doc.data() });
        });
        setTags(arr);
        setLoading(false);
      },
      (err) => {
        console.error("useTopTags:onSnapshot error", err);
        setError(err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [limitNum]);

  return { tags, loading, error };
}
